<template>
  <div class="rm-drawer-step">
    <div class="rm-drawer-scroll">
      <section class="drawer-section">
        <h3 class="drawer-section-title">
          {{ $t('ESTIMATE_REPAIRER_DETAIL.SUB_TITLE.SUMMARY') }}
        </h3>
        <v-card-secondary
          :key="repairerOffer"
          v-for="repairerOffer of currentRepairFile?.repairer_estimate
            ?.repairer_estimate_option_list"
          class="secondary-card-row pa-3"
        >
          <p class="drawer-offer-label">
            {{ $t('COMMON.PRODUCT_END_STATUS.' + repairerOffer.offer_type) }}
          </p>
          <p class="drawer-offer-price">
            {{ repairerOffer.total_cost.toFixed(2) }} {{ $t('COMMON.EURO') }}
          </p>
        </v-card-secondary>
      </section>

      <section class="drawer-section">
        <h3 class="drawer-section-title">
          {{ $t('ESTIMATE_REPAIRER_DETAIL.SUB_TITLE.INFORM_CLIENT') }}
        </h3>

        <!-- PHONE NUMBER -->
        <div class="drawer-field">
          <p class="custom-label">{{ $t('ESTIMATE_REPAIRER_DETAIL.CALL_CLIENT') }}</p>
          <v-text-field
            :model-value="currentRepairFile?.phone_number"
            :placeholder="$t('COMMON.PLACEHOLDER.PHONE_NUMBER')"
            hide-details
            readonly
            prepend-inner-icon="mdi-phone-outline"
          />
        </div>

        <!-- EMAIL -->
        <div class="drawer-field">
          <p class="custom-label">{{ $t('ESTIMATE_REPAIRER_DETAIL.SEND_ESTIMATE') }}</p>
          <v-text-field
            required
            v-model="email"
            :rules="[...requiredRules, ...emailRules]"
            hide-details="auto"
            :placeholder="$t('ESTIMATE_REPAIRER_DETAIL.PLACEHOLDER.SEND_ESTIMATE')"
            prepend-inner-icon="mdi-email-outline"
          />
        </div>

        <v-btn-secondary
          class="w-100"
          :disabled="loading"
          :loading="loading"
          prepend-icon="mdi-send-outline"
          variant="flat"
          @click="sendClientEmail"
        >
          {{ $t('ESTIMATE_REPAIRER_DETAIL.BUTTON.SEND_EMAIL') }}
        </v-btn-secondary>
      </section>
    </div>
  </div>
</template>

<script>
import ResponseConstant from '@/constants/responseConstant'
import { displayToast, handleResponseError } from '@/utils/toastUtils'
import Validators from '@/utils/validators'
import RepairFileService from '@/services/RepairFileService'
import EstimateRepairerService from '@/services/EstimateRepairerService'

export default {
  props: {
    currentRepairFile: Object
  },
  data() {
    return {
      loading: false,
      error: null,

      requiredRules: Validators.requiredRules,
      emailRules: Validators.emailRules,

      email: null,
      repairer_estimate_option_list: null
    }
  },
  created() {
    this.patchData()
  },
  mounted() {
    this.emitFooterState()
  },
  computed: {
    footerState() {
      return {
        disabled: this.loading,
        loading: this.loading
      }
    }
  },
  watch: {
    footerState: {
      handler() {
        this.emitFooterState()
      },
      deep: true
    }
  },
  methods: {
    emitFooterState() {
      this.$emit('updateFooterState', this.footerState)
    },
    submit() {
      return this.submitSaveEmail()
    },
    async submitSaveEmail() {
      if (this.email !== this.currentRepairFile.email) {
        this.loading = true
        try {
          const data = {
            repair_file_id: this.currentRepairFile.technical_id,
            contact_email: this.email
          }
          await RepairFileService.updateRepairFileEmail(data)
          displayToast(this.$t('ESTIMATE_REPAIRER_DETAIL.CUSTOMER_EMAIL_SAVE'), 'success')
        } catch (error) {
          handleResponseError(error)
          if (error.response.data.key) {
            this.setError(error.response.data.key)
          }
        } finally {
          this.loading = false
          this.$emit('updateCurrentRepairFile')
          this.$emit('openEstimateRepairerClientChoice')
        }
      }
      this.$emit('openEstimateRepairerClientChoice')
    },
    handleError(error) {
      this.setError(error.response.data.key)
      if (error.response?.data && error.response.data.key in ResponseConstant) {
        displayToast(this.$t('ERROR.' + ResponseConstant[error.response.data.key]), 'error')
      } else {
        displayToast(
          this.$t(
            'ERROR_STATUS_CODE_MESSAGE.' + (error.response ? error.response.status : 'UNKNOWN')
          ),
          'error'
        )
      }
    },
    setError(key) {
      switch (key) {
        case 'invalid_repairer_repair_file_number_error_key':
          this.error = { repairerNumber: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        default:
          this.error = ''
      }
    },
    patchData() {
      this.email = this.currentRepairFile?.email
    },
    async sendClientEmail() {
      this.loading = true
      try {
        const data = {
          repair_file_id: this.currentRepairFile.technical_id,
          contact_email: this.email
        }
        await EstimateRepairerService.sendRepairFileRepairerEstimateToClient(data)
        displayToast(this.$t('ESTIMATE_REPAIRER_DETAIL.MODAL.SEND_CLIENT_EMAIL'), 'success')
        this.$emit('updateCurrentRepairFile')
        this.$emit('closeNewAction')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    async backToRepairerOffersCreation() {
      this.loading = true
      try {
        await EstimateRepairerService.backToRepairerOffersCreation(
          this.currentRepairFile.technical_id
        )
        this.$emit('backToRepairerOffersCreation')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
